import React, { useEffect, useRef, useState } from 'react'
import { Container, Row, Col, Card, Form, Button, OverlayTrigger, Tooltip, Tab, Nav } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Select, { components } from "react-select"
import Swal from 'sweetalert2'
import Loader from '../components/loaders/Loader'
import { getDocumentsByEmployee } from '../actions/other/documentsActions'
import { AppDispatch, RootState } from '../store'
import { CustomDataTable } from '../components/design/Datatables/CustomDataTable'
import { useAuth } from '../components/auth/useAuth'

export interface DocumentFile {
    _id?: string
    name?: string
    url?: string
}

export interface Document {
    _id?: string
    title?: string
    description?: string
    files?: (File | DocumentFile)[]
    date?: string | Date
    roles?: string[]
    categories?: {
        _id?: string
        name?: string
    }[]
}

export default function Documents() {
    const { t } = useTranslation()
    const dispatch: AppDispatch = useDispatch()
    const { clientauth } = useAuth()

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(25)
    const [search, setSearch] = useState<string>("")
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState<number>(0)

    const { documents, loading, resultdocument } = useSelector((state: RootState) => state.documents)

    useEffect(() => {
        if (clientauth?.rol) {
            dispatch(getDocumentsByEmployee(page, limit, search, clientauth.id) as any)
        }
    }, [clientauth])

    const columnsDocuments = [
        {
            name: t('documentTranslate.date'),
            selector: (document: Document) =>
                document.date ? new Date(document.date) : new Date(0),
            cell: (document: Document) =>
                document.date ? new Date(document.date).toLocaleDateString() : '-',
            sortable: true,
        },
        {
            name: t('documentTranslate.categories'),
            selector: (document: Document) => document.categories,
            cell: (document: Document) => document.categories?.map(category => category?.name).join(', '),
            sortable: true,
        },
        {
            name: t('documentTranslate.title'),
            selector: (document: Document) => document.title || document.description,
            cell: (document: Document) => document.title || document.description,
            sortable: true,
        },
        {
            name: t('documentTranslate.documents'),
            cell: (document: Document) => (
                <>
                    {document.files && document.files.length > 0 ? (
                        <ul className="list-unstyled mb-0 text-start">
                            {document.files.map((file, index) => {
                                if ("url" in file) {
                                    return (
                                        <li key={(file as DocumentFile)._id || index}>
                                            <a
                                                href={(file as DocumentFile).url}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-dark"
                                            >
                                                {(file as DocumentFile).name}
                                            </a>
                                        </li>
                                    )
                                }

                                return (
                                    <li key={index}>
                                        <a
                                            href={URL.createObjectURL(file as File)}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-dark"
                                        >
                                            {(file as File).name}
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    ) : (
                        <span>-</span>
                    )}
                </>
            ),
            sortable: false,
        }
    ]

    useEffect(() => {
        if (resultdocument) {
            let resultnow = resultdocument
            dispatch({ type: 'DOCUMENT_RESET_RESULT' })
            switch (resultnow) {
                case 'addMultipleSuccess':
                    if (
                        typeof resultdocument !== 'string' &&
                        resultdocument?.rejectedFiles &&
                        resultdocument.rejectedFiles.length > 0
                    ) {
                        Swal.fire({
                            showConfirmButton: true,
                            showDenyButton: false,
                            confirmButtonText: t('global.ok'),
                            icon: 'warning',
                            text: t('documentTranslate.addMultipleSuccessWithIssues', {
                                rejectedFiles: resultdocument.rejectedFiles.join(', ')
                            })
                        });
                    } else {
                        Swal.fire({
                            showConfirmButton: true,
                            icon: 'success',
                            title: t('documentTranslate.addMultipleSuccess'),
                        });
                    }
                    break;

                default:
                    break;
            }
        }
        // eslint-disable-next-line
    }, [resultdocument, dispatch, t])

    return (
        <Container fluid className='contenido'>
            <Row>
                <Col className='mt-3 px-1'>
                    <Row>
                        <Col xs={12} >
                            <h1>{t('menus.documentsManagement')}</h1>
                        </Col>
                    </Row>
                    <Row className='mt-3 mb-5'>
                        <Col className='px-1'>
                            <Card>
                                <Card.Body>
                                    {loading ?
                                        <Loader />
                                        :
                                        (<Row className="justify-content-end">
                                            <Col xs={12} lg={4} className="d-flex">
                                                <input
                                                    type="text"
                                                    className="form-control me-2 input-search"
                                                    placeholder={t("datatables.buscar")}
                                                    value={searchAux || ""}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        setSearchAux(e.target.value);
                                                        setPage(1);
                                                    }}
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                                                        if (e.key === "Enter") {
                                                            setSearch(searchAux);
                                                            setPage(1);
                                                        }
                                                    }}
                                                />
                                                <Button
                                                    className="button-search"
                                                    onClick={() => setSearch(searchAux)}
                                                >
                                                    <i className="fas fa-search" />
                                                </Button>
                                            </Col>
                                        </Row>)
                                    }{
                                        documents?.length > 0 ?
                                            <>
                                                <div className='d-md-block d-none'>
                                                    <CustomDataTable
                                                        columns={columnsDocuments}
                                                        data={documents}
                                                        pagination
                                                        paginationServer
                                                        paginationTotalRows={totalRows}
                                                        searchText={search}
                                                        onChangeRowsPerPage={(newLimit: number, page: number) => {
                                                            if (limit !== newLimit) {
                                                                setLimit(newLimit);
                                                                setPage(1);
                                                            }
                                                        }}
                                                        onChangePage={(newPage: number) => {
                                                            setPage(newPage);
                                                        }}
                                                    />
                                                </div>
                                            </>
                                            :
                                            <p className='mt-4 text-center'>{t('documentTranslate.noDocuments')}</p>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}